<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Evolución de Evaluación de Desempeño Proveedor Interno</h6>
                </v-card-title>
                <v-card-text>
                    <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                        :items-per-page="500" hide-default-footer>
                        <template v-slot:header.puntaje1="{ header }">
                            Valor año {{ periodoanterior }}
                        </template>
                        <template v-slot:header.puntaje2="{ header }">
                            Valor año {{ periodo }}
                        </template>
                        <template slot="body.append">
                            <tr>
                                <th>
                                    <h6><b>PROMEDIO TOTAL</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promtotalant.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ promtotalpres.toFixed(2) }}</b></h6>
                                </th>
                                <th>
                                    <h6><b>{{ porcentaje.toFixed(3) }}</b></h6>
                                </th>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card-text>
            </v-card>
        </v-app>
    </div>
</template>

<style scoped>
.v-data-table__group.summary {
    display: none;
}
</style>
<script>
import axios from "../../../axios-auth";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
export default {

    data: (vm) => ({

        filtrocodgral: "",
        filtromes: "",
        filtroresponsable: "",
        filtroobserv: "",
        listadoequipo: [],
        date: new Date().toISOString().substr(0, 7),
        datehoy: new Date().toISOString().substr(0, 7),
        menu: false,
        modal: false,
        promtotalant: 0,
        promtotalpres: 0,
        porcentaje: 0,
        evoluciontotalant: 0,
        evoluciontotalpres: 0,
        cantidadtotal: 0,
        listado: [],
        periodo: moment().subtract(1, "year").year(),
        periodoanterior: moment().subtract(2, "year").year(),
        headers: [
            {
                text: "Proveedor",
                align: "start",
                sortable: false,
                value: "proveedor",
                width: "25%"
            },
            { text: "Valor año", value: "puntaje1", width: "10%" },
            { text: "Valor año actual", value: "puntaje2", width: "10%" },
            { text: "Evolución", value: "puntaje3", width: "10%" },

        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },

    methods: {

        formatDate(date) {
            if (!date) return null;
            const [year, month] = date.split("-");
            return `${month}/${year}`;
        },

        cargarListados() {
            this.vaciarModels();

            let self = this;

            axios
                .get("/RRHH/ListadoEvolucionDesempprove?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.evoluciontotalant = 0;
                    self.evoluciontotalpres = 0;
                    self.promtotalant = 0;
                    self.promtotalpres = 0;
                    self.porcentaje = 0;
                    self.cantidadtotal = 0;

                    self.listado = response.data;
                    for (let i = 0; i < response.data.length; i++) {
                        self.evoluciontotalant += parseFloat(response.data[i].puntaje1);
                        self.evoluciontotalpres += parseFloat(response.data[i].puntaje2);
                        self.cantidadtotal += 1;
                    }
                    self.promtotalant = self.evoluciontotalant / self.cantidadtotal
                    self.promtotalpres = self.evoluciontotalpres / self.cantidadtotal
                    self.porcentaje = self.promtotalpres / self.promtotalant

                })
                .catch((error) => {
                    self.listado = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.listado = [];
        },
    },
};
</script>